import instance from "@network/api";

export type ContactPayload = {
    name: string;
    email: string;
    message: string;
    subject?: string;
};

export async function submitContact(payload: ContactPayload) {
    const res = await instance.post("/v1/gift-link/contact", payload);
    return res.data;
}
